interface TechnologyItem {
  id: number;
  name: string;
  icon?: string;
}

const TechlogiesData: TechnologyItem[] = [
  // --- Fundamentos Web (Core) ---
  { id: 13, name: "Html" },
  { id: 14, name: "Css" },
  { id: 1, name: "JavaScript", icon: "../src/assets/pngs/javascript.png" },

  // --- Front-End & Frameworks ---
  { id: 2, name: "React JS" },
  { id: 5, name: "NextJs" },
  { id: 11, name: "Angular" },
  { id: 12, name: "Sass" },
  { id: 18, name: "Bootstrap" },
  { id: 4, name: "TypeScript" },

  // --- Back-End & Databases ---
  { id: 6, name: "NodeJs" },
  { id: 16, name: "Laravel" },
  { id: 8, name: "MySQL" },
  { id: 19, name: "Postgresql" },
  { id: 15, name: "Prisma" },

  // --- Linguagens de Programação ---
  { id: 7, name: "Python" },
  { id: 17, name: "Java" },
  { id: 20, name: "Springboot" },

  // --- DevOps & Ferramentas ---
  { id: 9, name: "Git" },
  { id: 10, name: "GitHub" },
  { id: 21, name: "Insomnia" },
  { id: 22, name: "Docker" },
  { id: 23, name: "Vercel" },
  { id: 24, name: "Chakra UI" },
  { id: 25, name: "SWC" }
];

export default TechlogiesData;
